import React, {useLayoutEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import {useTable} from 'components/organisms/Providers/TableProvider/TableProvider';
import StyledDealflowEntityProfileWrapper
  from 'components/templates/Wrappers/Dealflow/Entities/DealflowEntityProfileWrapper/DealflowEntityProfileWrapper.styles';
import DealflowEntityProfileProvider
  from 'components/organisms/Providers/ProfileProvider/DealflowEntityProfileProvider';
import DealflowEntitySectionPanel
  from 'components/organisms/SectionPanels/DealflowEntitySectionPanel/DealflowEntitySectionPanel';
import DealflowEntityProfileFoldout
  from 'components/organisms/Foldouts/DealflowEntityProfileFoldout/DealflowEntityProfileFoldout';
import EntityTaskProfileWrapper
  from 'components/templates/Wrappers/Tasks/EntityTaskProfileWrapper/EntityTaskProfileWrapper';
import useMediaQuery from '@mui/material/useMediaQuery';

const DealflowEntityProfileWrapper = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'DealflowEntityProfileWrapper');

  const foldoutRef = useRef(null);
  const tableProvider = useTable();

  const smDown = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const [size, setSize] = useState('larger');
  const [newProfile, setNewProfile] = useState(false);

  const handleProfileClose = () => {
    tableProvider.closeProfile();
  }

  const handleClose = (e, reason) => {
    foldoutRef.current?.close?.(e, reason);
  }

  const handleToggle = (e, open, reason) => {
    if (!open) {
      foldoutRef.current?.close?.(e, reason);
    }
  }

  const handleNext = (entity, isNew) => {
    tableProvider.openProfile(entity?.entityId, !isNew ? {activeSection: 'options'} : null);
  }

  const handleChange = (section) => {
    setSize(section.size ?? 'larger');
  }

  const handleCardClose = (card) => {
    if (card?.name === tableProvider.state?.showProfile?.settings?.activeCard) {
      tableProvider.closeProfile();
    }
  }

  const renderContext = () => {
    const entityId = tableProvider.state?.showProfile?.id;
    const settings = tableProvider.state?.showProfile?.settings;
    const state = (entityId && settings) ? {settings} : null;

    return <DealflowEntityProfileProvider entityId={entityId ?? -1} state={state}>
      <EntityTaskProfileWrapper>
        <DealflowEntityProfileFoldout ref={foldoutRef}
                                      onClose={handleProfileClose}
                                      newProfile={newProfile}>
          <DealflowEntitySectionPanel showProfile={true}
                                      newProfile={newProfile}
                                      onClose={handleClose}
                                      onCloseCard={handleCardClose}
                                      onNext={handleNext}
                                      onChange={handleChange}/>
        </DealflowEntityProfileFoldout>
      </EntityTaskProfileWrapper>
    </DealflowEntityProfileProvider>
  }

  useLayoutEffect(() => {
    if (Boolean(tableProvider.state?.showProfile?.id)) {
      setNewProfile(tableProvider.state?.showProfile?.id === -1 ? Date.now() : false);
    }
  }, [tableProvider.state?.showProfile?.id]);

  const keepMounted = Boolean(tableProvider.state?.showProfile?.id) && tableProvider.state?.showProfile?.settings?.hideProfile;

  return <StyledDealflowEntityProfileWrapper ref={ref} {...innerProps}
                                             size={smDown ? 'largest' : size}
                                             variant="foldout"
                                             context={renderContext()}
                                             open={Boolean(tableProvider.state?.showProfile?.id) && !tableProvider.state?.showProfile?.settings?.hideProfile}
                                             onToggle={handleToggle}
                                             ContextDrawerProps={keepMounted ? {
                                               ModalProps: {
                                                 keepMounted: true
                                               }
                                             } : null}>
    {innerProps.children}
  </StyledDealflowEntityProfileWrapper>
});

DealflowEntityProfileWrapper.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default DealflowEntityProfileWrapper;
